"use client"

import { usePermissions } from "@/context/permissions-context"
import { ReactNode } from "react"

interface PermissionGateProps {
  children: ReactNode
  requiredPermissions: string[]
  requireAll?: boolean
}

export function PermissionGate({
  children,
  requiredPermissions,
  requireAll = true,
}: PermissionGateProps) {
  const { hasAllPermissions, hasAnyPermission } = usePermissions()

  const hasPermission =
    requiredPermissions.length === 0
      ? true
      : requireAll
      ? hasAllPermissions(requiredPermissions)
      : hasAnyPermission(requiredPermissions)

  if (!hasPermission) {
    return null
  }

  return <>{children}</>
}